import {getField, updateField} from "vuex-map-fields";
import Repository from "@/repository";

const MESSAGE_API = "/message";

// A payload of {start: null, end: null} is a real state — it means "no range" —
// but it is not `== null`, so interpolating it into the query string sent
// `?from=null&to=null` and the server answered 400, leaving the list empty.
// Only bounds that actually have a value become params, and they go through
// axios so the +03:00 offset is encoded rather than decoded into a space.
function dateParams(payload) {
    let params = {};
    if (payload && payload.start) params.from = payload.start;
    if (payload && payload.end) params.to = payload.end;
    return params;
}

// ----------------------- STATE ------------------------- //
const state = {
    message_data: [],
    currentIndex: -1,
    selectedItems: [],
    unread:0,
    read:0,
    total:0,
};

// ----------------------- GETTERS ----------------------- //
const getters = {
    getMessage: state => getField(state.message_data[state.currentIndex]),

    getFilterByGroup: (state) => (group) => {
        let data = [];
        switch(group){
            case "Unread": data = state.message_data.filter(element => element.status == 1); break;
            case "Read": data = state.message_data.filter(element => element.status == 3); break;
            default: data = state.message_data;
        }
        return data;
    },

    getCurrentMessage: state => {
        return state.message_data[state.currentIndex];
    },
    getLastMessages: state => maxItems => {
        if (state.message_data.length > maxItems - 1) {
            return state.message_data.slice(0, maxItems);
        } else {
            return state.message_data;
        }
    },

    unreadMessages: state => {
        if (state.message_data.length == 0) {
            return 0;
        }else{
            let read = 0;
            state.message_data.forEach(element => {
                if (element.status == 3) {
                    read += 1;

                }
            })

            return state.message_data.length - read;
        }

    }

};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
    updateMessage(state, payload) {
        updateField(state.message_data[state.currentIndex], payload);
    },

    setCurrentIndexByID(state, theID) {
        state.currentIndex = state.message_data.findIndex(
            message => message.id == theID
        );
    },

    setNext(state){
        state.currentIndex += 1;
        if(state.message_data[state.currentIndex].status != null){
            state.message_data[state.currentIndex].status = 3;
        }
    },
    setPrevious(state){
        state.currentIndex -= 1;
        if(state.message_data[state.currentIndex].status != null){
            state.message_data[state.currentIndex].status = 3;
        }
    },

    setSelectedItems(state,payload){
      state.selectedItems = payload;
    },


    markCurrentAsRead(state){
        if(state.message_data[state.currentIndex].status != null){
            state.message_data[state.currentIndex].status = 3;
        }
    },

    loadAllMessages(state, payload) {
        state.message_data = payload.data;
        state.currentIndex = 0;
    },



    addMessage(state, payload) {
        state.message_data.unshift(payload.data);
        state.currentIndex = state.message_data.length - 1;
    },

    saveContactMessage(state, payload) {
        state.message_data[state.currentIndex] = payload.data;
    },

    fetchMessage(state, payload) {
        if (state.currentIndex == -1) {
            state.message_data.push(payload.data);
            state.currentIndex = 0;
        } else {
            state.message_data[state.currentIndex] = payload.data;
        }
    },

    fetchMessageListByReference(state, payload) {
        if (payload.data.length > 0) {
            state.currentIndex = 0;
        }
        state.message_data = payload.data;
    },

    deleteMessage(state, payload) {
        state.currentIndex = state.message_data.findIndex(
            message => message.id == payload.data.id
        );
        state.message_data.splice(state.currentIndex, 1);
        state.currentIndex = 0;
    },

    deleteManyMessages(state,payload){
      let deletedIDs  = payload.data;

            deletedIDs.forEach(id => {
                for(let i=0; i<state.message_data.length; i++) {
                    if(id === state.message_data[i].id){
                        state.message_data.splice(i, 1);
                    }
                }

            })
    },
    markManyAsRead(state,payload){
      let deletedIDs  = payload.data;
            deletedIDs.forEach(id => {
                for(let i=0; i<state.message_data.length; i++) {
                    if(id === state.message_data[i].id){
                        state.message_data[i].status = 3;
                    }
                }

            })
    },

    reCalculateStatus(state) {
        state.unread = 0;
        state.total = 0;
        state.message_data.forEach(element => {
            if (element.status == 1) {
                state.unread += 1;

            }
            state.total += 1;
        })

        state.read = state.total - state.unread;
    },

    ContactMessageStatus(state, payload) {
        state.unread = payload.data.unread
        state.total = payload.data.total
        state.read = payload.data.read
    },
    reset(state) {
        state.message_data = []
        state.currentIndex = -1
        state.selectedItems = []
    }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
    async loadAllContactMessages({commit},payload) {
        try {
            commit("loadAllMessages", await Repository.get(`${MESSAGE_API}/contact`, {params: dateParams(payload)}));
        } catch (error) {
            console.log(error);
        }
    },

    async ContactMessageStatus({commit}) {
        try {
            commit("ContactMessageStatus", await Repository.get(`${MESSAGE_API}/contact/count`));
        } catch (error) {
            console.log(error);
        }
    },

    async loadAllMessages({commit},payload) {
        try {
            commit("loadAllMessages", await Repository.get(`${MESSAGE_API}`, {params: dateParams(payload)}));
        } catch (error) {
            console.log(error);
        }
    },

    async addMessage({commit}, payload) {
        await Repository.post(`${MESSAGE_API}/new`, payload)
            .then(response => {
                commit("addMessage", response);
            })
            .catch(error => {
                console.log(error);
            });
    },

    async saveContactMessage({state, commit}) {
        try {
            commit(
                "saveContactMessage",
                await Repository.post(
                    `${MESSAGE_API}`,
                    state.message_data[state.currentIndex]
                )
            );
        } catch (error) {
            console.log(error);
        }
    },

    async fetchMessage({commit}, payloadID) {
        try {
            commit(
                "fetchMessage",
                await Repository.get(`${MESSAGE_API}/${payloadID}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async fetchMessageListByReference({commit}, referenceID) {
        try {
            console.log(`${MESSAGE_API}/reference/${referenceID}`);
            commit(
                "fetchMessageListByReference",
                await Repository.get(`${MESSAGE_API}/reference/${referenceID}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async deleteManyMessages({commit},payload) {
        try {
            commit(
                "deleteManyMessages",
                await Repository.post(`${MESSAGE_API}/${payload.type}/delete`,payload.ids)
            );
        } catch (error) {
            console.log(error);
        }
    },
    async markManyAsRead({commit},payload) {
        try {
            commit(
                "markManyAsRead",
                await Repository.post(`${MESSAGE_API}/contact/markManyAsRead`,payload)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async deleteMessage({commit}, payloadID) {
        try {
            commit(
                "deleteMessage",
                await Repository.delete(`${MESSAGE_API}/${payloadID}`)
            );
        } catch (error) {
            console.log(error);
        }
    },

    async searchMessages({commit}, searchTerm) {
        try {
            commit(
                "loadAllMessages",
                await Repository.get(`${MESSAGE_API}/search?q=${searchTerm}`)
            );
        } catch (error) {
            console.log(error);
        }
    }
};
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
